import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refPmmCompleteGuideDownloadPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={
            'PMM PM PdM プロダクトマーケティングマネージャー プロジェクトマネージャー プロダクトマネージャー GAFAM Go-to-Market戦略 SaaS グロース戦略'
          }
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/download/pmm-complete-guide/done/'}
          title="ご入力いただきありがとうございます | PMMのすべて ーPdMと一体化したプロダクト成功の方程式ー | 資料ダウンロード | Aitria（アイトリア）"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
